import { useEffect, useRef, useState } from "react";
import type { LabelPinAdminStatus } from "../../../shared/labels/pin-contracts";
import { labelPinAdminApi } from "./label-pin-api";

export function useLabelPinAdminWorkspace({ userId }: { userId: string }) {
  const [status, setStatus] = useState<LabelPinAdminStatus | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const mounted = useRef(false);
  const pending = useRef<AbortController | null>(null);
  useEffect(() => {
    mounted.current = true;
    void run();
    return () => { mounted.current = false; pending.current?.abort(); };
  }, [userId]);
  async function run(input?: { pin: string; sendEmail: boolean }) {
    if (pending.current) return;
    const controller = new AbortController();
    pending.current = controller;
    setBusy(true); setError(""); setMessage("");
    const snapshot = status;
    try {
      if (input && snapshot) {
        const result = await labelPinAdminApi.setCredential(userId, {
          pin: input.pin, sendEmail: input.sendEmail, expectedVersion: snapshot.version ?? 0,
        }, controller.signal);
        if (mounted.current && !controller.signal.aborted) {
          setMessage(result.delivery === "queued"
            ? "PIN kaydedildi ve e-posta gönderim kuyruğuna alındı. Teslim durumu ayrıca doğrulanır."
            : "PIN kaydedildi. PIN'i ilgili kişiye güvenli biçimde iletebilirsiniz.");
        }
      }
      const latest = await labelPinAdminApi.status(userId, controller.signal);
      if (mounted.current && !controller.signal.aborted) setStatus(latest);
    } catch (cause: unknown) {
      if (mounted.current && !controller.signal.aborted) setError(cause instanceof Error ? cause.message : "PIN durumu alınamadı. Yenileyin.");
    } finally {
      if (pending.current === controller) pending.current = null;
      if (mounted.current) setBusy(false);
    }
  }
  return { status, busy, error, message, refresh: () => run(), setCredential: (input: { pin: string; sendEmail: boolean }) => run(input) };
}
